<template>
  <div>
    <Tree :data="data" class="tree" :render="renderContent"></Tree>
  </div>
</template>
<script>
export default {
  name: 'GradeList',
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    branchid: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'cancel', 'lost'],
  data() {
    return {
      data: []
    };
  },
  computed: {
  },
  watch: {
    treeData(newVal) {
      this.data = this.treeDataList(newVal, this.branchid);
    },
    branchid(newVal) {
      this.data = this.treeDataList(this.treeData, newVal);
    }
  },
  created() {},
  methods: {
    // 处理数据
    treeDataList(data, branchId) {
      if (data) {
        const deleteArr = [];
        data.forEach((branch, index) => {
          if (branch.branchId !== branchId && branchId) {
            deleteArr.push(index);
            return;
          }
          branch.title = branch.branchName;
          branch.isShow = false;
          this.$set(branch, 'expand', true);
          branch.children = branch.grades;
          branch.gradeId = '';
          branch.gradeName = '';
          branch.classId = '';
          branch.className = '';
          branch.children.forEach(grade => {
            grade.title = grade.gradeName;
            grade.isShow = true;
            this.$set(grade, 'expand', false);
            grade.children = grade.classes;
            grade.branchName = branch.branchName;
            grade.classId = '';
            grade.className = '';
            grade.children.forEach(clas => {
              clas.title = clas.className;
              clas.isShow = false;
              clas.branchName = branch.branchName;
              clas.branchId = branch.branchId;
              clas.gradeId = grade.gradeId;
              clas.gradeName = grade.gradeName;
            });
          });
        });
        deleteArr.forEach((item) => {
          data.splice(item, 1);
          item--;
        });
      }
      return data;
    },
    renderContent(h, { root, node, data }) {
      return h('div', {
        style: {
          width: '100%'
        }
      }, [
        h('span', data.title),
        h('span', [
          data.isShow
            ? h('span', {
              style: {
                float: 'right',
                color: 'rgb(45, 115, 235)'
              },
              class: 'btn',
              on: {
                click: () => { this.$emit('choose', data); }
              }
            }, '设为可报') : ''
        ])
      ]);
    }
  }
};
</script>
<style lang="scss" scoped>
  .tree {
    line-height: 24px;
    .font-14 {
      font-size: 14px;
      line-height: 24px;
    }
    .align-middle {
      display: flex;
      align-items: center;
    }
    .ml-4 {
      margin-left: 16px;
    }
    .ml-6 {
      margin-left: 24px;
    }
    /deep/ .ivu-icon-ios-arrow-forward:before {
      content: '\F33D';
      font-size: 24px;
    }
    /deep/ .ivu-icon-ios-arrow-forward:before {
      // 改变tree默认的三角箭头
      // content: "\F128"; // 采用ui库中自带的icon图标
      content: '\F341';
      font-size: 24px;
    }
    /deep/ .ivu-tree-title {
      box-sizing: border-box;
      padding: 0 8px;
      width: 100%;
    }
    /deep/  .btn {
      display: none;
    }
    /deep/ .ivu-tree-title-selected .btn {
      display: inline-block;
    }
    /deep/ .ivu-tree-title:hover .btn {
      display: inline-block;
    }
  }
</style>
